import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../config/firebase'; // Certifique-se de importar o 'db'
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore"; // Importes necessários para consultar o Firestore
import { Building2, Lock, Mail, LogIn, Loader2 } from 'lucide-react';
import './LoginScreen.css';

export default function LoginScreen() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // 1. Realiza a autenticação básica no Firebase Auth
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // 2. Verifica se a empresa existe na coleção 'companies'
      // Ajuste o nome da coleção para 'users' ou 'partners' se necessário
      const docRef = doc(db, "companies", user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        // Sucesso: Usuário autenticado e empresa validada no banco
        navigate('/cadastro');
      } else {
        // Erro: Autenticado, mas não consta como empresa parceira
        await signOut(auth); // Expulsa o usuário da sessão
        alert('Acesso negado: Esta conta não possui registro de empresa ativo.');
      }

    } catch (err) {
      console.error("Erro no login:", err);
      // Tratamento de erros comuns do Firebase Auth
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
        alert('E-mail ou senha incorretos.');
      } else {
        alert('Ocorreu um erro ao tentar entrar. Tente novamente mais tarde.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="logo-section" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>
          <Building2 size={50} color="#6366F1" />
          <h1 className="brand-name">ACHEVAM</h1>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          <div className="input-wrapper">
            <Mail size={20} color="#94A3B8" className="input-icon" />
            <input 
              type="email" 
              placeholder="E-mail da Empresa" 
              className="login-input" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required 
            />
          </div>
          <div className="input-wrapper">
            <Lock size={20} color="#94A3B8" className="input-icon" />
            <input 
              type="password" 
              placeholder="Senha" 
              className="login-input" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
            />
          </div>
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? <Loader2 className="animate-spin" /> : 'Entrar no Painel'}
          </button>
        </form>

        <div className="links-container">
          <button type="button" onClick={() => navigate('/register')} className="link-blue">
            Não tem conta? Cadastre sua empresa
          </button>
          <div className="footer-row">
            <button type="button" onClick={() => navigate('/forgot-password')} className="link-gray">
              Esqueci minha senha
            </button>
            <span className="divider">|</span>
            <button type="button" className="link-gray" onClick={() => navigate('/')}>
              Voltar ao Início
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}